//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../../../library/umum.js'
import WILAYAH from  '../../../../library/getWilayah'
import FETCHING from  '../../../../library/fetching'
import uniqid from 'uniqid';


export default {
  data() {
    return {

      form : {
        id : '',
        kk : '',
        des_kel : this.$store.state.ID_DES_KEL,
        pria : '',
        wanita : '',
        tahun : '',
        createdAt : '',
      },
     
      list_data : [],

      page_limit : 14,
      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_ADM_DESA_KELUARGA + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              tahun: this.form.tahun,
              des_kel : this.form.des_kel
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },


    addData : function(number) {
      // console.log(this.$store.state.listPekerjaan) 
      this.form.id = uniqid();
      this.form.createdAt = UMUM.NOW();
      fetch(this.$store.state.url.URL_ADM_DESA_KELUARGA + "addData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          this.getView();
      });


    },


    editData : function(){
      fetch(this.$store.state.url.URL_ADM_DESA_KELUARGA + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_ADM_DESA_KELUARGA + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){

        this.form.id = data.id;
        this.form.des_kel = data.des_kel;
        this.form.tahun = data.tahun;
        this.form.kk = data.kk;
        this.form.pria = data.pria;
        this.form.wanita = data.wanita;
        this.form.createdAt = data.createdAt;

    },
    btnAdd(){
      if (this.form.des_kel == '') {
        alert("PILIH DESA TERLEBIH DAHULU")
      } else {
        FETCHING.postPekerjaan(this.form.tahun, this.form.des_kel)
        this.mdl_add = true
      }
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },


        // fetching : async function(){
        //   var ss = await FETCHING.getJenisUsaha();
        //   console.log(ss)
        // }




    // ====================================== PAGINATE ====================================







  },

  mounted () {

    var profilex = JSON.parse(localStorage.profile)
      var profile = profilex.profile
      this.$store.state.ID_DES_KEL = profile.des_kel
      this.form.des_kel = profile.des_kel

      
    this.form.tahun = UMUM.getTahun();
    WILAYAH.getListDesKelFull();
    this.getView();
    // FETCHING.getJenisUsaha();


    
  },
}
